// Checkout linking is authorized. Payment processing is not yet configured.
export const PREVIEW_MODE: boolean = false;
export const PAYMENTS_ENABLED: boolean = false;

export const CHECKOUT_URL =
  "https://hockey-class-ready.impultienda.ar/checkout";

export const META_PIXEL_ID = "1694090148804823";

export const PRODUCT_NAME = "FloorHockeyClassReady — 12 Beginner Lessons";
